/**
 * @fileoverview Zod schemas for Review rows and weekly summaries.
 */
import { z } from 'zod';

export const ReviewRowSchema = z
  .object({
    id: z.string(),
    user_id: z.string(),
    timeframe_mode: z.string().optional().nullable(),
    timezone_created_in: z.string().optional().nullable(),
    window_from: z.string().optional().nullable(),
    window_to: z.string().optional().nullable(),
    tasks_total: z.number().optional().nullable(),
    tasks_done: z.number().optional().nullable(),
    completion_rate: z.number().optional().nullable(),
    overdue_count: z.number().optional().nullable(),
    per_goal: z.any().optional().nullable(),
    summary_text: z.string().optional().nullable(),
    created_at: z.string(),
  })
  .passthrough();

export type ReviewRow = z.infer<typeof ReviewRowSchema>;

export const WeeklySummarySchema = z
  .object({
    weekStart: z.string(),
    weekEnd: z.string(),
    chatCount: z.number().optional(),
    messageCount: z.number().optional(),
    tasksTotal: z.number().optional(),
    tasksDone: z.number().optional(),
    completionRate: z.number().optional(),
    overdueCount: z.number().optional(),
    perGoal: z.any().optional(),
    summaryText: z.string().optional(),
    created_at: z.string().optional(),
  })
  .passthrough();

export type WeeklySummary = z.infer<typeof WeeklySummarySchema>;
